function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInitiativesActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 13.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-initiatives-active") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.53,4.24H13.24a.53.53,0,0,1,.53.53v7.94a.53.53,0,0,1-.53.53H.53A.53.53,0,0,1,0,12.71V4.76A.53.53,0,0,1,.53,4.24Zm14.29,6.62V3.18H2.38a.27.27,0,0,1-.27-.27V2.38a.26.26,0,0,1,.26-.27h13a.53.53,0,0,1,.53.53v8.21a.27.27,0,0,1-.27.26h-.52A.26.26,0,0,1,14.82,10.85Zm2.12-2.12V1.06H4.5A.27.27,0,0,1,4.24.79V.27A.26.26,0,0,1,4.5,0h13A.53.53,0,0,1,18,.53V8.74a.27.27,0,0,1-.27.26h-.52A.26.26,0,0,1,16.94,8.74Z",
    style: {
      fill: "#3fa9f5"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInitiativesActive);
export default __webpack_public_path__ + "static/media/icon-initiatives-active.673cb7a88a6b8c20bfddeb2f73f07176.svg";
export { ForwardRef as ReactComponent };